import { Card, Col, Form, Input, Radio, Row, Space, Typography } from "antd";
import React, { useEffect } from "react";
const { Title } = Typography;

const Recipient = ({ getChildData, patientDetailsFMLA, form }) => {

  const callparent = (e, name) => {
    getChildData(e, name);
  };

  useEffect(() => {
    if (patientDetailsFMLA.recordsDisclose == "self") {
      let res =
        patientDetailsFMLA.IsPatient == "yes"
          ? patientDetailsFMLA.PFirstName + " " + patientDetailsFMLA.PLastName
          : patientDetailsFMLA.RequesterFName +
          " " +
          patientDetailsFMLA.RequesterLName;


      let phone =
        patientDetailsFMLA.IsPatient == "yes"
          ? patientDetailsFMLA.PatientPhoneNumber
          : patientDetailsFMLA.RequesterPhoneNumber;

      let email =
        patientDetailsFMLA.IsPatient == "yes"
          ? patientDetailsFMLA.PEmail
          : patientDetailsFMLA.RequesterEmail;

      form.setFieldsValue({ nameorganization: res, rphone: phone, remail: email });
    }
  }, [patientDetailsFMLA.IsPatient]);


  const onChangeRadio = (e) => {
    getChildData(e.target.value, "RecipientDiscloseRecordsTo");
    if (e.target.value == "self") {
      let res =
        patientDetailsFMLA.IsPatient == "yes"
          ? patientDetailsFMLA.PFirstName + " " + patientDetailsFMLA.PLastName
          : patientDetailsFMLA.RequesterFName +
          " " +
          patientDetailsFMLA.RequesterLName;

      let phone =
        patientDetailsFMLA.IsPatient == "yes"
          ? patientDetailsFMLA.PatientPhoneNumber
          : patientDetailsFMLA.RequesterPhoneNumber;

      let email =
        patientDetailsFMLA.IsPatient == "yes"
          ? patientDetailsFMLA.PEmail
          : patientDetailsFMLA.RequesterEmail;

      form.setFieldsValue({ nameorganization: res, rphone: phone, remail: email });
    }
    else {
      form.setFieldsValue({ nameorganization: "", rphone: "", remail: "", vemail: "" });
    }
  };
  const validatePhone = (_, value) => {
    // Example regex for phone number validation (adjust as needed)
    const phoneRegex = /^[+]?[0-9]{10,15}$/;
    if (!value || phoneRegex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("Please enter a valid phone number."));
  };

  const validateConfirmEmail = (_, value) => {
    const email = form.getFieldValue('remail');
    if (value && value !== email) {
      return Promise.reject(new Error('Verify email does not match with email.'));
    }
    return Promise.resolve();
  };
  
  return (
    <Card
      bordered={false}
      size="0"
      title={
        <Title
          className="font-semibold"
          style={{ marginBottom: "0" }}
          level={4}
        >
          Recipient Information
        </Title>
      }
    >
      <Form.Item
        className="font-medium"
        name="discloserecord"
        label="Who would you like to disclose the form to?"
        required
        rules={[{ required: true, message: "Please choose any option." }]}
      >
        <Radio.Group onChange={onChangeRadio} >
          <Space direction="vertical" className="ms-4"
          >
            <Radio value="self" className="font-normal">
              Self
            </Radio>
            <Radio value="employer/insurance" className="font-normal">
              Employer/Insurance
            </Radio>
            {/* <Radio value="both" className="font-normal">
              Both
            </Radio> */}
          </Space>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        className="font-medium"
        label="What method of release would you like?"
        required
        name="releasemethod"
        rules={[{ required: true, message: "Please choose any option." }]}
      >
        <Radio.Group
          onChange={(e) => {
            callparent(e.target.value, "RecipientMethodOfRelease");
          }}
          value={patientDetailsFMLA.RecipientMethodOfRelease}
        >
          <Space direction="vertical" className="ms-4"
          >
            <Radio value="email" className="font-normal">
              Email
            </Radio>
            <Radio value="fax" className="font-normal">
              Fax
            </Radio>
          </Space>
        </Radio.Group>
      </Form.Item>

      {patientDetailsFMLA.RecipientMethodOfRelease.toString() && (
        <Row gutter={[20, 0]} className="mt-4">
          <Col xs={24} md={12}>
            <Form.Item
              className="font-medium"
              label="Name/Organization"
              onChange={(e) => callparent(e.target.value, "RecipientName")}
              required
              name="nameorganization"
              rules={[
                {
                  required: true,
                  max: 110,
                  message: "Please enter name or organization.",
                },
              ]}
            >
              <Input maxLength={110} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}></Col>
          {patientDetailsFMLA.RecipientMethodOfRelease.toString() ===
            "email" ? (
            <>
              <Col xs={24} md={12}>
                <Form.Item
                  className="font-medium"
                  label="Email"
                  onChange={(e) => callparent(e.target.value, "RecipientEmail")}
                  required
                  name="remail"
                  rules={[
                    { required: true, max: 100, message: "Please enter email." },
                    { type: "email", message: "Please enter valid email." },
                  ]}
                >
                  <Input maxLength={100} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="vemail"
                  className="font-medium"
                  label="Verify Email"
                  onChange={(e) =>
                    callparent(e.target.value, "RecipientVerifyEmail")
                  }

                  rules={[
                    { required: true, max: 100, message: "Please enter email." },
                    { validator: validateConfirmEmail }
                  ]}
                >
                  <Input maxLength={100} />
                </Form.Item>
              </Col>
            </>
          ) : (
            <>
              <Col xs={24} md={12}>
                <Form.Item
                  className="font-medium"
                  label="Fax Number"
                  onChange={(e) => callparent(e.target.value, "RecipientFax")}
                  name="faxnumber"
                  rules={[
                    { required: true, max: 20, message: "Please enter fax number." },
                  ]}
                >
                  <Input maxLength={20} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  className="font-medium"
                  label="Phone Number"
                  onChange={(e) =>
                    callparent(e.target.value, "RecipientPhoneNumber")
                  }
                  required
                  name="phone"
                  rules={[
                    {
                      required: true,
                      max: 20,
                      message: "Please enter phone number.",
                    },
                    { validator: validatePhone },
                  ]}
                >
                  <Input maxLength={20} />
                </Form.Item>
              </Col>
            </>
          )}
        </Row>
      )}
    </Card>
  );
};
export default Recipient;
